import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const HealthWellnessPage = lazy(() => import('../pages/health-wellness/page'));
const SkincareePage = lazy(() => import('../pages/skincare/page'));
const PersonalCarePage = lazy(() => import('../pages/personal-care/page'));
const NaturalCarePage = lazy(() => import('../pages/natural-care/page'));
const VitaminsPage = lazy(() => import('../pages/vitamins/page'));
const MineralsPage = lazy(() => import('../pages/minerals/page'));
const HeartHealthPage = lazy(() => import('../pages/heart-health/page'));
const BrainSupportPage = lazy(() => import('../pages/brain-support/page'));
const ImmunityPage = lazy(() => import('../pages/immunity/page'));
const SportsNutritionPage = lazy(() => import('../pages/sports-nutrition/page'));
const RadiantBeautyPage = lazy(() => import('../pages/radiant-beauty/page'));
const DailyGroomingPage = lazy(() => import('../pages/daily-grooming/page'));
const BeautySupplementPage = lazy(() => import('../pages/beauty-supplement/page'));
const PostWorkoutPage = lazy(() => import('../pages/post-workout/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/health-wellness',
    element: <HealthWellnessPage />
  },
  {
    path: '/skincare',
    element: <SkincareePage />
  },
  {
    path: '/personal-care',
    element: <PersonalCarePage />
  },
  {
    path: '/natural-care',
    element: <NaturalCarePage />
  },
  {
    path: '/vitamins',
    element: <VitaminsPage />
  },
  {
    path: '/minerals',
    element: <MineralsPage />
  },
  {
    path: '/heart-health',
    element: <HeartHealthPage />
  },
  {
    path: '/brain-support',
    element: <BrainSupportPage />
  },
  {
    path: '/immunity',
    element: <ImmunityPage />
  },
  {
    path: '/sports-nutrition',
    element: <SportsNutritionPage />
  },
  {
    path: '/radiant-beauty',
    element: <RadiantBeautyPage />
  },
  {
    path: '/daily-grooming',
    element: <DailyGroomingPage />
  },
  {
    path: '/beauty-supplement',
    element: <BeautySupplementPage />
  },
  {
    path: '/post-workout',
    element: <PostWorkoutPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
